/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import { TextSortable } from './text.Sortable';
import { update } from '../../services/item';
import { canEditItemForItem, getId } from '../../utils/item';
import { isTouchOnlyContext } from '../../utils/inputCapabilities';
import { isEditable } from '../../utils/roles';

export const TextAll = props => {
  const { itemId } = props;

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const isModalOpen = useSelector(state => state.global.openModales);
  const isMobile = useSelector(state => state.global.isMobile);
  const isTouch = useSelector(state => state.global.isTouch);
  const [texts, setTexts] = useState(item?.text);
  const canEdit = canEditItemForItem(item, items);
  const touchLocked = isTouchOnlyContext(isTouch);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 5,
      },
    })
  );

  const handleDragEnd = event => {
    const { active, over } = event;
    if (active.id !== over.id) {
      setTexts(prev => {
        const oldIndex = prev.findIndex(
          item => Object.keys(item)[0] === active.id
        );
        const newIndex = prev.findIndex(
          item => Object.keys(item)[0] === over.id
        );
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  useEffect(() => {
    if (item?.text) {
      setTexts(item.text);
    }
  }, [item?.text]);

  useEffect(() => {
    if (
      texts?.length === item?.text?.length &&
      JSON.stringify(texts) !== JSON.stringify(item?.text)
    ) {
      update(`items/${itemId}`, 'text', texts);
    }
  }, [texts]);

  return (
    <div className='h-full w-full flex-1'>
      {texts?.length > 0 && (
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={texts.map(tabObj => getId(tabObj))}
            strategy={verticalListSortingStrategy}
            disabled={
              isEditable() === false ||
              isEditable(Object.values(isModalOpen).includes(true)) ||
              isMobile ||
              touchLocked ||
              !canEdit
            }
          >
            {texts.map(tabObj => (
              <TextSortable
                key={getId(tabObj)}
                id={getId(tabObj)}
                textId={getId(tabObj)}
                itemId={itemId}
              />
            ))}
          </SortableContext>
        </DndContext>
      )}
    </div>
  );
};
